const AWSLambdaServerless = () => {
  return <h1>AWSLambdaServerless  </h1>;
};

export default AWSLambdaServerless;